export default __webpack_public_path__ + "static/DriveScore-44ab5f4677bbc9bae0ae132433c85373.png";